import { render, staticRenderFns } from "./ProductCreateDialog.vue?vue&type=template&id=21b3c052&scoped=true"
import script from "./ProductCreateDialog.vue?vue&type=script&lang=js"
export * from "./ProductCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductCreateDialog.vue?vue&type=style&index=0&id=21b3c052&prod&scoped=true&lang=less"
import style1 from "./ProductCreateDialog.vue?vue&type=style&index=1&id=21b3c052&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3c052",
  null
  
)

export default component.exports